export {
  default as diningArea,
  ReactComponent as DiningArea,
} from '@assets/icons/features-and-amenities/dining-area.svg'    
